<template>
    <v-container class="error-message-container py-15 d-flex justify-center align-center flex-column">
        <div class="error-message-content py-5 px-5">
            <h2 class="title">Dashboard</h2>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'Dashboard',
    props: {},
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.error-message-container {
    text-align: center;
    height: 100%;
}

.icon-error-url {
    height: 250px;
}

.error-message-content {
    .title {
        font-size: 26px;
        font-weight: bold;
    }

    .description {
        font-size: 16px;
        margin-top: 16px;
    }
}
</style>
